
import './style/ConfirmOfferModal.css';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import TextArea from './TextArea';
import LabelInput from './LabelInput';
import Modal from './Modal';
import ReCAPTCHA from 'react-google-recaptcha';

import OfferSuccess from '../../media/offer-success.png';

import { genericRequest, setShowGenericRequestConfirmation } from '../../redux/temporarySlice';
import { validateEmail } from '../../util/Validation';
import { Button, Text } from '@harperai/materialize-design-system';

const GenericRequestModal = (
    {
        requestType,
        showModal,
        setShowModal
    }) => {
    const captchaSiteKey = window.location?.href?.includes('localhost') ? '6LeRb4AqAAAAAMi0AgNFSMFxyw9bo5q2wePZ9p3u' : '6LeVWn8qAAAAAHHCHAzhrmTQjuadBu9fzePxRzyo';

    const dispatch = useDispatch();
    const genericRequestProcessing = useSelector((state) => state.temporary?.genericRequestProcessing);
    const showGenericRequestConfirmation = useSelector((state) => state.temporary?.showGenericRequestConfirmation);

    const [continueButtonLoading, setContinueButtonLoading] = useState(false);
    const [errorsVisible, setErrorsVisible] = useState(false);
    const [errorShake, setErrorShake] = useState(false);

    const [captchaResponse, setCaptchaResponse] = useState(null);
    const [captchaComplete, setCaptchaComplete] = useState(false);

    const modalTitle = requestType === "ASK A QUESTION (PRODUCT PAGE)" ? "Ask a question" : "UNSET";
    const modalCta = requestType === "ASK A QUESTION (PRODUCT PAGE)" ? "Submit" : "UNSET";
    const modalConfirmationTitle = requestType === "ASK A QUESTION (PRODUCT PAGE)" ? "Your question has been received!" : "UNSET";
    const modalConfirmationSubtitle = requestType === "ASK A QUESTION (PRODUCT PAGE)" ? "Our team is reviewing your question and will reach out as soon as possible." : "UNSET";

    const modalTextArea = requestType === "ASK A QUESTION (PRODUCT PAGE)" ? true : false;

    const [requestInfo, setRequestInfo] = useState({
        fullName: "",
        email: ""
    });

    const handleInputChange = (e, key) => {
        const existingInfo = { ...requestInfo };
        existingInfo[key] = e.target.value;
        setRequestInfo(existingInfo);
    };

    const handleCaptchaChange = (value) => {
        if (value) {
            setCaptchaComplete(true);
            setCaptchaResponse(value);
        }
    };

    const handleFormSubmit = () => {
        if (requestInfo?.fullName === '' ||
            requestInfo?.email === '' ||
            !validateEmail(requestInfo?.email) ||
            !captchaComplete) {
            setErrorsVisible(true);
            setErrorShake(true);
            setTimeout(() => {
                setErrorShake(false);
            }, 1000);
            return;
        } else {
            setErrorsVisible(false);
            let request = {
                recaptcha_response: captchaResponse,
                email: requestInfo.email,
                name: requestInfo.fullName,
                metadata: {
                    request_type: requestType,
                    current_page: window.location.href
                }
            }

            if (requestInfo?.company) {
                request.company = requestInfo.company;
            }

            if (requestInfo?.details) {
                request.metadata.details = requestInfo.details;
            }
    
            dispatch(genericRequest(request));
        }
    }

    const handleContinue = () => {
        setContinueButtonLoading(true);
        setTimeout(() => {
            handleCloseModal();
            setContinueButtonLoading(false);
        }, 700);
    };

    const handleCloseModal = () => {
        setShowModal(false)
        dispatch(setShowGenericRequestConfirmation(false));
    };
    
    return (
        <Modal showModal={showModal} setShowModal={setShowModal} content={(
            <div id="modal-shadow" className={`small-modal flex vertical pad-xl gap-xl ${errorShake ? 'error-shake':''}`} onClick={null}>
                {!showGenericRequestConfirmation && (
                    <div className="flex horizontal flex-1 gap-xl align-center space-between">
                        <Text header={2} size="h5" bold={true}>{modalTitle}</Text>
                        <Button
                            variant="grey"
                            size="large"
                            icon="xmark"
                            onClick={handleCloseModal}
                        />
                    </div>
                )}
                {!showGenericRequestConfirmation ? (
                    <div className="flex vertical flex-1 gap-xl gap-l">
                        <div className="flex vertical gap-xl">
                            <div className="flex vertical gap-m">
                                <Text header={3} size="title" bold={true}>How can we reach you?</Text>
                                <div className="flex vertical gap-l">
                                    <LabelInput
                                        label="Full Name"
                                        horizontal={true}
                                        onChange={(e) => handleInputChange(e, "fullName")}
                                        onWhite={true}
                                        autoComplete="name"
                                        classes={errorsVisible && requestInfo?.fullName === '' ? "error" : ""}
                                        labelStyle={{flexBasis: "124px"}}
                                        inputStyle={{flexGrow: "1"}} />
                                    <LabelInput
                                        label="Email"
                                        horizontal={true}
                                        onChange={(e) => handleInputChange(e, "email")}
                                        value={requestInfo.email}
                                        onWhite={true}
                                        autoComplete="email"
                                        type="email"
                                        disallowSpaces={true}
                                        classes={errorsVisible && (requestInfo?.email === '' || !validateEmail(requestInfo?.email)) ? "error" : ""}
                                        labelStyle={{flexBasis: "124px"}}
                                        inputStyle={{flexGrow: "1"}} />
                                </div>
                            </div>
                            {modalTextArea && (
                                <div className="flex vertical gap-m">
                                    <Text header={3} size="title" bold={true}>What's on your mind?</Text>
                                    <TextArea
                                        type="text"
                                        large={true}
                                        onWhite={true}
                                        classes={errorsVisible && (!requestInfo?.details || requestInfo?.details === '') ? "error" : ""}
                                        onChange={(e) => handleInputChange(e, "details")} />
                                </div>
                            )}
                        </div>
                        <div className={`flex horizontal flex-wrap gap-s align-start ${errorsVisible && !captchaComplete ? "error" : ""}`}>
                            <ReCAPTCHA
                                sitekey={captchaSiteKey} 
                                onChange={handleCaptchaChange} />
                            <div className="flex vertical align-stretch flex-1 gap-s space-between">
                                <Button
                                    variant="primary"
                                    size="large"
                                    icon="plane"
                                    onClick={handleFormSubmit}
                                    loading={genericRequestProcessing}
                                >
                                    {modalCta}
                                </Button>
                            </div>
                        </div>
                    </div>
                 ) : (
                    <div className="flex vertical align-center gap-l pad-l no-pad-left no-pad-right">
                        <img src={OfferSuccess} style={{height: "64px"}} alt="Offer Success" />
                        <div className="flex vertical align-center center-text gap-xs">
                            <Text header={2} size="h5" bold={true}>{modalConfirmationTitle}</Text>
                            <Text header={3} size="paragraph" variant="secondary" bold={true}>{modalConfirmationSubtitle}</Text>
                        </div>
                        <Button onClick={handleContinue} loading={continueButtonLoading} size="large">Continue</Button>
                    </div>
                 )}
            </div>
        )}/>
    );
};

export default GenericRequestModal;